import { __decorate, __extends } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';

var RadioPage = function (_super) {
  __extends(RadioPage, _super);

  function RadioPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RadioPage.prototype.handleChange = function () {
    this.$emit('input', this.value);
  };

  __decorate([Prop({
    type: Array,
    "default": []
  })], RadioPage.prototype, "children", void 0);

  __decorate([Prop({
    type: Array,
    "default": []
  })], RadioPage.prototype, "value", void 0);

  RadioPage = __decorate([Component({})], RadioPage);
  return RadioPage;
}(Vue);

export default RadioPage;